"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M7.35,2.85V7.2H3V2.85H7.35M8.74,1.46H1.61V8.59H8.74V1.46Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M19.32,2.85V7.2H15V2.85h4.36m1.39-1.39H13.57V8.59h7.14V1.46Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M7.35,14.79v4.36H3V14.79H7.35M8.74,13.4H1.61v7.14H8.74V13.4Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "10.36",
    y: "1.44",
    width: "1.67",
    height: "6.4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "7.68",
    y: "11.05",
    width: "13.05",
    height: "1.61"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "1.61",
    y: "11.05",
    width: "3.4",
    height: "1.61"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M13.42,15H10.77v1.61h1.91A6.51,6.51,0,0,1,13.42,15Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M17.86,13.5A4.53,4.53,0,1,0,22.39,18,4.53,4.53,0,0,0,17.86,13.5Zm1.6,4.87H18.2v1.26a.34.34,0,1,1-.68,0V18.36H16.27a.34.34,0,1,1,0-.68h1.26V16.43a.34.34,0,1,1,.68,0v1.26h1.26a.34.34,0,0,1,0,.68Z"
  })));
};

exports["default"] = _default;